<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    <div class="flex items-center h-10">
      <vs-chip class="ag-grid-cell-chip" color="success" >
        <span>출석{{attendCount}}</span>
      </vs-chip>
      <vs-chip class="ag-grid-cell-chip" color="warning"  >
        <span>지각{{lateCount}}</span>
      </vs-chip>
      <vs-chip class="flex items-center justify-center  ag-grid-cell-chip" color="danger" >
        <span>결석{{missCount}}</span>
      </vs-chip>
    </div>
  </div>
</template>

<script>
  export default {
      name: 'AttendTotal',
      data() {
        return {
          missCount: 0,
          lateCount: 0,
          attendCount: 0,
          memeberInfo:null,
          newDay: true,
        }
      },
      watch: {
        attendDays(){
          this.$store.dispatch('space/getMembers', {'id' : this.activeWorkspace.id}).then(()=>{
            this.memeberInfo = this.$store.getters['space/getMemberInfo'](this.params.data.user_id)
            // var today = this.$moment(new Date()).format('YYYY-MM-DD')
            this.missCount = this.memeberInfo.miss_count
            this.lateCount = this.memeberInfo.late_count
            this.attendCount = this.memeberInfo.attend_count
          })
        },
        updateDataFalg(){
          this.$store.dispatch('space/getMembers', {'id' : this.activeWorkspace.id}).then(()=>{
            this.memeberInfo = this.$store.getters['space/getMemberInfo'](this.params.data.user_id)
            // var today = this.$moment(new Date()).format('YYYY-MM-DD')
            this.missCount = this.memeberInfo.miss_count
            this.lateCount = this.memeberInfo.late_count
            this.attendCount = this.memeberInfo.attend_count
          })          
        }
      },
      computed: {
        activeWorkspace() {
          return this.$store.state.space.ActiveSpaceInfo
        },
        workspaceMembers(){
          return this.$store.state.space.workspaceMembers
        },
        attendDays(){
          return this.$store.state.attend.attendDays
        },
        updateDataFalg(){
          return this.$store.state.attend.updateDataFalg
        },
      },
      methods: {
        setTotalData(){
          // if(this.newDay){
          //   if(this.$store.getters['attend/getAttendLate'](this.params.data.id)){
          //     this.attendCount = this.memeberInfo.attend_count
          //     this.missCount = this.memeberInfo.miss_count
          //     this.lateCount = this.memeberInfo.late_count + 1
          //   }
          //   else if(this.$store.getters['attend/getAttendMiss'](this.params.data.id)){
          //     this.attendCount = this.memeberInfo.attend_count
          //     this.missCount = this.memeberInfo.miss_count + 1
          //     this.lateCount = this.memeberInfo.late_count
          //   }
          //   else {
          //     this.attendCount = this.memeberInfo.attend_count + 1
          //     this.missCount = this.memeberInfo.miss_count
          //     this.lateCount = this.memeberInfo.late_count
          //   }
          // }else{
          //   if(this.$store.getters['attend/getAttendLate'](this.params.data.id)){
          //     this.attendCount = this.memeberInfo.attend_count -1
          //     this.missCount = this.memeberInfo.miss_count
          //     this.lateCount = this.memeberInfo.late_count + 1
          //   }
          //   else if(this.$store.getters['attend/getAttendMiss'](this.params.data.id)){
          //     this.attendCount = this.memeberInfo.attend_count - 1
          //     this.missCount = this.memeberInfo.miss_count + 1
          //     this.lateCount = this.memeberInfo.late_count
          //   }
          //   else {
          //     this.attendCount = this.memeberInfo.attend_count
          //     this.missCount = this.memeberInfo.miss_count
          //     this.lateCount = this.memeberInfo.late_count
          //   }
          // }
        },
      },
      created(){
        this.memeberInfo = this.$store.getters['space/getMemberInfo'](this.params.data.user_id)
        // var today = this.$moment(new Date()).format('YYYY-MM-DD')
        this.missCount = this.memeberInfo.miss_count
        this.lateCount = this.memeberInfo.late_count
        this.attendCount = this.memeberInfo.attend_count
        // for (var index in this.attendDays)

      }

  }
</script>
